var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplateBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 366,
    height: 218,
    viewBox: "0 0 366 218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_29851",
    x: -9,
    y: -6,
    width: 384,
    height: 236,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7988b8",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-template-background"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366,
    height: 218
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "template-background",
    clipPath: "url(#clip-template-background)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16872",
    "data-name": "Group 16872",
    transform: "translate(4959 15958)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4959, -15958)",
    filter: "url(#Rectangle_29851)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29851-2",
    "data-name": "Rectangle 29851",
    width: 366,
    height: 218,
    rx: 10,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16441",
    "data-name": "Group 16441"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29852",
    "data-name": "Rectangle 29852",
    width: 317,
    height: 64,
    rx: 10,
    transform: "translate(-4935 -15938)",
    fill: "#f0f4f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29854",
    "data-name": "Rectangle 29854",
    width: 317,
    height: 15,
    rx: 7.5,
    transform: "translate(-4935 -15862)",
    fill: "#f0f4f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29855",
    "data-name": "Rectangle 29855",
    width: 317,
    height: 15,
    rx: 7.5,
    transform: "translate(-4935 -15834)",
    fill: "#f0f4f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29857",
    "data-name": "Rectangle 29857",
    width: 317,
    height: 46,
    rx: 10,
    transform: "translate(-4935 -15806)",
    fill: "#f0f4f8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateBackground);
export default __webpack_public_path__ + "static/media/template-background.e2f2075e204a3526ddc1db5a1291b4a4.svg";
export { ForwardRef as ReactComponent };